// import logo from "./logo.svg";
// import "./App.css";
// import Header from "./Aviator/Header";
// import Leftside from "./Aviator/Leftside";
// import Login from "./pages/Login";
// import HomePage from "./pages/Home";
// import Bettingbutton from "./Aviator/Bettingbutton";
// import Result from "./pages/Result";
// import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
// import { useLocation } from "react-router-dom";

// function App() {
//   const location = useLocation();

//   return (
//     <div className="padding_all">
//       <Router>
//         <Routes>
//           <Route path="/" element={<Login />} />
//           <Route path="/home" element={<HomePage />} />
//           <Route path="/Bettingbutton" element={<Bettingbutton key={location.search} />} />
//           <Route path="/Result" element={<Result key={location.search} />} />
//           {/* <Route
//             path=""
//             element={
//               <div>
//                 <Header />
//                 <div className="d-flex gap-2">
//                   <Leftside />
//                   <div className="w-100">
//                     <Routes>
//                       <Route element={<HomePage />} path="/home"></Route>
//                     </Routes>
//                   </div>
//                 </div>
//               </div>
//             }
//           ></Route> */}
//         </Routes>
//       </Router>
//     </div>
//   );
// }

import "./App.css";
import Leftside from "./Aviator/Leftside";
import Login from "./pages/Login";
import HomePage from "./pages/Home";
import Bettingbutton from "./Aviator/Bettingbutton";
import Result from "./pages/Result";
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";

function App() {
  const location = useLocation();


  return (
    <div className="padding_all">
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/home" element={<HomePage />} />
        <Route path="/Bettingbutton" element={<Bettingbutton />} />
        <Route path="/Result" element={<Result key={location.search} />} />
        <Route path="/Leftside" element={<Leftside key={location.search} />} />
        {/* Add additional routes here */}
      </Routes>
    </div>
  );
}

function Root() {
  return (
    <Router>
      <App />
    </Router>
  );
}

export default Root;


